export const makeItorator = (length) => [...(function* () {
  let itoration = 0
  for(let i = 0; i < length; i ++){
    itoration++
    yield i
  }
  return itoration
})()]